export default __webpack_public_path__ + "bb3f1da65c83480909859b903c3851ba.png";